import { Phone } from "lucide-react";

const FloatingCall = () => {
  return (
    <a
      href="tel:0662125192"
      data-testid="floating-call-btn"
      aria-label="Appeler Escarg'Holala"
      className="fixed bottom-24 right-4 sm:bottom-6 sm:right-6 z-40 flex items-center gap-2 rounded-full bg-bordeaux text-white font-600 pl-4 pr-5 py-3 shadow-[0_10px_30px_rgba(114,47,55,0.5)] hover:bg-bordeaux-dark hover:-translate-y-0.5 transition-all"
    >
      <Phone size={18} className="animate-pulse" />
      <span className="hidden sm:inline text-sm">Appelez-nous</span>
    </a>
  );
};

export default FloatingCall;
